<template>
    <div class="vue-filter-group vue-filter-group-v2" v-if="options.length > 1" :class="[open ? 'open' : 'closed', activeFilters.length > 0 ? 'has-active-filters' : '']" v-click-outside="() => { this.open = false }">
        <button @click="handleToggle">{{ label }}</button>

        <div class="dropdown-wrapper" v-show="open">
            <aut-filter-option
                v-for="option in options"
                :key="option.id"
                :filter="option"
                :group-id="groupId"
                :active-filters="activeFilters"
                @clicked="handleClicked"
            ></aut-filter-option>
        </div>
    </div>
</template>

<script>
import translations from "../../mixins/translations";
import ClickOutside from "vue-click-outside";
import FilterOption from "./FilterOption";

export default {
    name: "FilterGroup",

    components: {
        'aut-filter-option': FilterOption
    },

    mixins: [translations],

    directives: {ClickOutside},

    props: ['label', 'options', 'groupId', 'eventBus'],

    data() {
        return {
            suffixMapping: {},
            activeFilters: [],
            open: false,
        }
    },

    mounted() {

      this.suffixMapping = {
          'multi_class': '',
          'transmission': '',
          'fuel': '',
          'amount_of_persons': this.translations.amountOfPersonsSuffix,
          'suitcases': this.translations.suitcasesSuffix,
          'amount_of_doors': this.translations.amountOfDoorsSuffix,
      };

        this.options.forEach((option) => {
            option.label = this.suffixMapping[this.groupId].length > 0 ? `${option.label} ${this.suffixMapping[this.groupId]}` : option.label;
        });

        this.options.sort((a, b) => {
            return a.weight - b.weight;
        });

        this.eventBus.$on('clear-filters', () => {
            this.activeFilters = [];
        });

        this.eventBus.$on('remove-filter', (payload) => {
            if (!lodash.isEqual(this.groupId, payload.groupId)) {
                return;
            }

            this.activeFilters.splice(this.activeFilters.indexOf(
                lodash.find(this.activeFilters, (item) => {
                    return item.id === payload.id;
                })
            ), 1);
        });
    },


    methods: {
        handleClicked(filter) {
            if (lodash.includes(this.activeFilters, filter)) {
                this.activeFilters.splice(this.activeFilters.indexOf(filter), 1);
                return;
            }

            this.activeFilters.push(filter);

        },

        handleToggle() {
            this.open = !this.open;
        }
    },

    watch: {
        activeFilters() {
            this.$emit('active-filters-changed', {
                groupId: this.groupId,
                filters: lodash.map(this.activeFilters, 'id')
            });
        }
    }
}
</script>
